import { UPDATE_DMX_PROFILE, UPDATE_DMX_PROFILE_SUCCESSFUL, UPDATE_DMX_PROFILE_FAILED } from './actionTypes';

export const updateDmxProfile = (profile) => {
  return {
    type: UPDATE_DMX_PROFILE,
    payload: { profile },
  };
};

export const updateDmxProfileSuccessful = (message) => {
  return {
    type: UPDATE_DMX_PROFILE_SUCCESSFUL,
    payload: message,
  };
};

export const updateDmxProfileFailed = (message) => {
  return {
    type: UPDATE_DMX_PROFILE_FAILED,
    payload: message,
  };
};
